/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { LegalEntityValidationService } from '../common/legal-entity-validation.service';
import { inject, Injectable } from '@angular/core';
import { CompanyCustomerResourceService } from '@well/resource-services';

@Injectable()
export class CompanyLegalEntityValidationService implements LegalEntityValidationService {
  resourceService = inject(CompanyCustomerResourceService);
  exists(country: string, uniqueIdentificationNumber: string) {
    const numericId = uniqueIdentificationNumber.replace(/\D/g, '');
    return this.resourceService.customerExists(country, numericId);
  }
}
